import Heading from "common/components/Typography/Heading/Heading";
import React from "react";
import { Col } from "react-bootstrap";
import { Row } from "react-bootstrap";
import styles from "./OneFel.module.css";
import { formatCurrency } from "common/helpers/DataFormat";
import { Container } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { Trash2Fill } from "react-bootstrap-icons";
import { Trash } from "react-bootstrap-icons";
import { FiletypePdf } from "react-bootstrap-icons";
import { FiletypeXml } from "react-bootstrap-icons";
export default function OneFel(props){
    const {pos,data,onButtonCallBack} = props;
    return <div className={styles.container}>
            
                                <Container>
                                    <Row>
                                        <Col xs={8}>
                                    <Row>
                                        <Col><Heading variant="h4">Factura #{pos+1}</Heading></Col>
                                    </Row>
                                    <Row>
                                        <Col className={styles.labeldatafactura} xs={2}>Serie:</Col>
                                        <Col xs={5}>{data.FELData.info.autorizacion.serie} &nbsp; <span className={styles.labeldatafactura}>Número:</span> &nbsp; {data.FELData.info.autorizacion.numero}</Col>
                                        <Col xs={1}></Col>
                                        <Col xs={1}></Col>
                                    </Row>
                                    <Row>
                                        <Col className={styles.labeldatafactura} xs={2}>Autorización:</Col>
                                        <Col xs={6}>{data.FELData.info.autorizacion.value}</Col>
                                        <Col> </Col>
                                        <Col></Col>
                                    </Row>
                                    <Row>
                                        <Col className={styles.labeldatafactura} xs={2}>Emisión:</Col>
                                        <Col xs={4}>{data.FELData.info.fecha_emision}</Col>
                                        <Col className={styles.labeldatafactura} xs={1}>Monto:</Col>
                                        <Col>{formatCurrency(data.FELData.info.moneda,data.FELData.info.monto)}</Col>
                                    </Row>
                                    </Col>
                                    <Col>
                                        <Row className={styles.buttonsfel}>
                                            <Col>
                                           
                                                <Button className={styles.btnfel} onClick={()=> onButtonCallBack("XML",data.xml) }><FiletypeXml /> XML</Button>
                                            </Col>
                                            <Col>
                                                <Button className={styles.btnfel} onClick={()=> onButtonCallBack("PDF",data.pdf) }><FiletypePdf /> PDF</Button>
                                            </Col>
                                            <Col>
                                                <Button className={styles.btnfel} variant="danger" onClick={()=> onButtonCallBack("delete",{ pos: pos }) }><Trash /> </Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                    </Row>
                                </Container>
         
            {console.log("factura ",pos,data)}
    </div>;
}